async function domReady() {
  return new Promise((resolve) => {
    if (document.readyState === "complete" || document.readyState === "interactive") {
      resolve();
    } else {
      document.addEventListener("DOMContentLoaded", resolve, { once: true });
    }
  });
}

async function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function init() {
  await domReady();
  parse();
}

function parse() {
  document.querySelectorAll('product-card').forEach(el => {
    const selector = 'div[class^="Vtl-WishlistIcon__Wrapper"]';
    const icon = el.querySelector(selector);
    if (icon) {
      moveIcon(icon);
    }
    else {
      const observer = new MutationObserver((mutations) => {
        const icon = el.querySelector(selector);
        if (icon) {
          moveIcon(icon);
          observer.disconnect();
        }
      });

      observer.observe(el, {
        childList: true,
        subtree: true
      });
    }

  });
}

function moveIcon(el) {
  let parent = el;
  for (let i = 0; i < 4; i++) {
    if (parent.parentElement) {
      parent = parent.parentElement;
    }
  }
  parent.appendChild(el);
}

init();
